import React, { useEffect, useState, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import request from '../../services/Request';
import Title from './Title';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import { formatBytes } from '../../services/method/methods';
import ReactApexChart from 'react-apexcharts';

const useStyles = makeStyles({
  depositContext: {
    flex: 1,
  },
});

export default function Deposits(props) {
  const [usage, setUsage] = useState('');
  const [dataused, setdataused] = useState(0);
  const [data, setData] = useState([
    { name: 'Used', value: 0 },
    { name: 'Free', value: 1000000000 },
  ]);

  const ss = useMemo(() => ({
    series: [data[0].value, data[1].value],
    options: {
      chart: {
        width: 180,
        height: 180,
        type: 'pie',
      },
      labels: ['Used', 'Free'],
      theme: {
        monochrome: {
          enabled: true,
        },
      },
      plotOptions: {
        pie: {
          dataLabels: {
            offset: -5,
          },
        },
      },
      grid: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
      },
      dataLabels: {
        formatter(val, opts) {
          const name = opts.w.globals.labels[opts.seriesIndex];
          return [name, formatBytes(opts.w.globals.initialSeries[opts.seriesIndex])];
        },
      },
      legend: {
        show: false,
      },
    },
  }), [data]);

  useEffect(() => {
    //get user data
    // return console.log(props.user);
    const getUserData = async () => {
      await request({
        method: 'get',
        url: `/users/edit/${props.user?._id}`,
      }).then((res) => {
        const features = res.data?.features;
        console.log('features?.current_disk_used', features?.current_disk_used);
        if (res.data?.features) {
          if (features?.current_disk_used > 0) {
            setdataused(features?.current_disk_used);
            if (features?.disk_usage_limit) {
              let uag = 1000000000;
              if (features?.disk_usage_limit == '0') {
                uag = 1000000000;
              } else if (features?.disk_usage_limit == '1') {
                uag = 5000000000;
              } else if (features?.disk_usage_limit == '2') {
                uag = 10000000000;
              }

              console.log('left', uag - features?.current_disk_used);
              setData([
                { name: 'Used', value: features?.current_disk_used },
                { name: 'Free', value: uag - features?.current_disk_used },
              ]);
            }
          }
        }
        console.log('userInfo', res.data);
      });
    };
    getUserData();
    return () => {
      setUsage(0);
      setdataused(0);
      setData([
        { name: 'Used', value: 0 },
        { name: 'Free', value: 1000000000 },
      ]);
    };
  }, []);

  const classes = useStyles();
  return (
    <div>
      <React.Fragment>
        {/* <Title>Welcome</Title> */}
        <Typography component="p" variant="h5" style={{ marginTop: '5px' }}>
          {/* {props.name} */}
          Role: {props.role}
        </Typography>
        {props.role === 'User' ? (
          <Typography color="textSecondary" className={classes.depositContext}>
            {props.fullAccess ? `You have full access` : `You have limited access`}
          </Typography>
        ) : (
          <div className="mt-4"></div>
        )}
        <div>
          <div>Cloud usage</div>
          <div id="chart" style={{ display: 'flex', justifyContent: 'center', overflow: 'hidden' }}>
            <ReactApexChart options={ss.options} series={ss.series} type="pie" />
          </div>
          <div id="html-dist"></div>
        </div>
      </React.Fragment>
    </div>
  );
}
